import React from 'react';
import {Table} from 'semantic-ui-react';
import Decimal from "../../components/formatters/decimal";

export default class ContractsTradingPositionTableRow extends React.Component {

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.month}</Table.Cell>
                <Table.Cell><Decimal value={this.props.data.baseTotalCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.baseTradedCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.baseExposedCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.baseTradeWA} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.peakTotalCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.peakTradedCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.peakExposedCapacity} /></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.peakTradeWA} /></Table.Cell>
            </Table.Row>
        );
    }
}